/**
 * Constantes para imagens estáticas usadas no LaTeX
 * 
 * IMPORTANTE: O backend deve copiar todas essas imagens para o diretório de compilação do LaTeX.
 * As imagens devem estar disponíveis em backend/assets/ ou backend/logo/ e serem copiadas
 * para o diretório temporário onde o LaTeX é compilado.
 * 
 * Lista de imagens que o backend precisa copiar:
 * - PLR-CAT.png
 * - Tabelaconv.png
 * - arcelor-logo.jpg
 * - arcelor-lateral.jpg
 * - tecnicum-schmersal-logo.png
 * - praxis-cover.jpg
 * - praxis-tecnicum-logo.jpg
 * - praxis-schmersal-logo.jpg
 * - praxis-fluxograma-risco.jpg
 * - praxis-medidas-protecao.jpg
 * - praxis-exemplos-perigos.jpg
 * - praxis-pl-sil.jpg
 * - praxis-plr-diagrama.jpg
 * - praxis-tabela-gs.jpg
 * - praxis-tabela-fe.jpg
 * - praxis-tabela-po.jpg
 * - praxis-tabela-np.jpg
 * - praxis-tabela-hrn.jpg
 * - praxis-legenda-checklist.jpg
 * - praxis-icon-mecanico.jpg
 * - praxis-icon-eletrico.jpg
 * - praxis-icon-ergonomico.jpg
 * - praxis-icon-check-verde.jpg
 * - praxis-icon-check-azul.jpg
 * - praxis-icon-circulo-azul.jpg
 * - praxis-icon-circulo-vermelho.jpg
 * - praxis-assinatura-modelo.jpg
 * - praxis-fallback-panoramica.jpg
 * - praxis-fallback-identificacao.jpg
 * - praxis-fallback-risco-mecanico.jpg
 * - praxis-fallback-risco-eletrico.jpg
 * - ar-cover-photo.png
 * - ar-cover-gear.png
 * - ar-cover-logo.png
 * - ar-header-logo.png
 * - Lauan.jpg
 * - Luciano.jpg
 */

/**
 * Nomes dos arquivos de imagens estáticas usadas no LaTeX
 */
export const IMAGENS_ESTATICAS = {
  /** Imagem da tabela PLR/Categoria (Determinação da categoria e nível de desempenho) */
  PLR_CAT: 'PLR-CAT.png',
  
  /** Imagem da tabela de conversão HRN */
  TABELA_CONVERSAO: 'Tabelaconv.png',
  
  /** Logo da ArcelorMittal (capa do documento) */
  ARCELOR_LOGO: 'arcelor-logo.jpg',
  
  /** Imagem lateral da ArcelorMittal (capa do documento) */
  ARCELOR_LATERAL: 'arcelor-lateral.jpg',
  
  /** Logo Tecnicum Schmersal (cabeçalho das páginas) */
  TECNICUM_SCHMERSAL_LOGO: 'tecnicum-schmersal-logo.png',

  /** Assets do template Praxis extraídos do PDF modelo */
  PRAXIS_COVER: 'praxis-cover.jpg',
  PRAXIS_TECNICUM_LOGO: 'praxis-tecnicum-logo.jpg',
  PRAXIS_SCHMERSAL_LOGO: 'praxis-schmersal-logo.jpg',
  PRAXIS_FLUXOGRAMA_RISCO: 'praxis-fluxograma-risco.jpg',
  PRAXIS_MEDIDAS_PROTECAO: 'praxis-medidas-protecao.jpg',
  PRAXIS_EXEMPLOS_PERIGOS: 'praxis-exemplos-perigos.jpg',
  PRAXIS_PL_SIL: 'praxis-pl-sil.jpg',
  PRAXIS_PLR_DIAGRAMA: 'praxis-plr-diagrama.jpg',
  PRAXIS_TABELA_GS: 'praxis-tabela-gs.jpg',
  PRAXIS_TABELA_FE: 'praxis-tabela-fe.jpg',
  PRAXIS_TABELA_PO: 'praxis-tabela-po.jpg',
  PRAXIS_TABELA_NP: 'praxis-tabela-np.jpg',
  PRAXIS_TABELA_HRN: 'praxis-tabela-hrn.jpg',
  PRAXIS_LEGENDA_CHECKLIST: 'praxis-legenda-checklist.jpg',
  PRAXIS_ICON_MECANICO: 'praxis-icon-mecanico.jpg',
  PRAXIS_ICON_ELETRICO: 'praxis-icon-eletrico.jpg',
  PRAXIS_ICON_ERGONOMICO: 'praxis-icon-ergonomico.jpg',
  PRAXIS_ICON_CHECK_VERDE: 'praxis-icon-check-verde.jpg',
  PRAXIS_ICON_CHECK_AZUL: 'praxis-icon-check-azul.jpg',
  PRAXIS_ICON_CIRCULO_AZUL: 'praxis-icon-circulo-azul.jpg',
  PRAXIS_ICON_CIRCULO_VERMELHO: 'praxis-icon-circulo-vermelho.jpg',
  PRAXIS_ASSINATURA_MODELO: 'praxis-assinatura-modelo.jpg',
  PRAXIS_FALLBACK_PANORAMICA: 'praxis-fallback-panoramica.jpg',
  PRAXIS_FALLBACK_IDENTIFICACAO: 'praxis-fallback-identificacao.jpg',
  PRAXIS_FALLBACK_RISCO_MECANICO: 'praxis-fallback-risco-mecanico.jpg',
  PRAXIS_FALLBACK_RISCO_ELETRICO: 'praxis-fallback-risco-eletrico.jpg',

  /** Assets do template AR Blueprint extraídos do PDF modelo */
  AR_COVER_PHOTO: 'ar-cover-photo.png',
  AR_COVER_GEAR: 'ar-cover-gear.png',
  AR_COVER_LOGO: 'ar-cover-logo.png',
  AR_HEADER_LOGO: 'ar-header-logo.png',
  
  /** Assinatura do executante */
  ASSINATURA_EXECUTANTE: 'Lauan.jpg',
  
  /** Assinatura do responsável técnico */
  ASSINATURA_RESPONSAVEL: 'Luciano.jpg',
} as const;

/**
 * Lista completa de todas as imagens estáticas necessárias para compilação LaTeX
 * Esta lista pode ser usada pelo backend para verificar e copiar as imagens necessárias
 */
export const TODAS_IMAGENS_ESTATICAS: readonly string[] = [
  IMAGENS_ESTATICAS.PLR_CAT,
  IMAGENS_ESTATICAS.TABELA_CONVERSAO,
  IMAGENS_ESTATICAS.ARCELOR_LOGO,
  IMAGENS_ESTATICAS.ARCELOR_LATERAL,
  IMAGENS_ESTATICAS.TECNICUM_SCHMERSAL_LOGO,
  IMAGENS_ESTATICAS.PRAXIS_COVER,
  IMAGENS_ESTATICAS.PRAXIS_TECNICUM_LOGO,
  IMAGENS_ESTATICAS.PRAXIS_SCHMERSAL_LOGO,
  IMAGENS_ESTATICAS.PRAXIS_FLUXOGRAMA_RISCO,
  IMAGENS_ESTATICAS.PRAXIS_MEDIDAS_PROTECAO,
  IMAGENS_ESTATICAS.PRAXIS_EXEMPLOS_PERIGOS,
  IMAGENS_ESTATICAS.PRAXIS_PL_SIL,
  IMAGENS_ESTATICAS.PRAXIS_PLR_DIAGRAMA,
  IMAGENS_ESTATICAS.PRAXIS_TABELA_GS,
  IMAGENS_ESTATICAS.PRAXIS_TABELA_FE,
  IMAGENS_ESTATICAS.PRAXIS_TABELA_PO,
  IMAGENS_ESTATICAS.PRAXIS_TABELA_NP,
  IMAGENS_ESTATICAS.PRAXIS_TABELA_HRN,
  IMAGENS_ESTATICAS.PRAXIS_LEGENDA_CHECKLIST,
  IMAGENS_ESTATICAS.PRAXIS_ICON_MECANICO,
  IMAGENS_ESTATICAS.PRAXIS_ICON_ELETRICO,
  IMAGENS_ESTATICAS.PRAXIS_ICON_ERGONOMICO,
  IMAGENS_ESTATICAS.PRAXIS_ICON_CHECK_VERDE,
  IMAGENS_ESTATICAS.PRAXIS_ICON_CHECK_AZUL,
  IMAGENS_ESTATICAS.PRAXIS_ICON_CIRCULO_AZUL,
  IMAGENS_ESTATICAS.PRAXIS_ICON_CIRCULO_VERMELHO,
  IMAGENS_ESTATICAS.PRAXIS_ASSINATURA_MODELO,
  IMAGENS_ESTATICAS.PRAXIS_FALLBACK_PANORAMICA,
  IMAGENS_ESTATICAS.PRAXIS_FALLBACK_IDENTIFICACAO,
  IMAGENS_ESTATICAS.PRAXIS_FALLBACK_RISCO_MECANICO,
  IMAGENS_ESTATICAS.PRAXIS_FALLBACK_RISCO_ELETRICO,
  IMAGENS_ESTATICAS.AR_COVER_PHOTO,
  IMAGENS_ESTATICAS.AR_COVER_GEAR,
  IMAGENS_ESTATICAS.AR_COVER_LOGO,
  IMAGENS_ESTATICAS.AR_HEADER_LOGO,
  IMAGENS_ESTATICAS.ASSINATURA_EXECUTANTE,
  IMAGENS_ESTATICAS.ASSINATURA_RESPONSAVEL,
];

